'use es6';

import debounce from 'react-utils/debounce';
import { CALLOUT_ATTRIBUTE, CALLOUT_TYPE_CLASS_PREFIX, CALLOUT_CLASSES } from '../constants/hscallout';
import { EDIT_CALLOUT } from '../constants/usageTracking';
import { isNestedFirstChild, isNestedLastChild } from '../hsformatting/utils';
import { getCalloutType, getParentCallout } from '../utils/callout';
import { getFirstInnerMostLeaf, getLastInnerMostLeaf, isEmptyParagraph } from '../utils/dom';
import { trackInteraction } from '../utils/usageTracking';
const KEY_BACKSPACE = 8;
const KEY_DELETE = 46;
export function addHandlers(editor) {
  editor.on('KeyDown', evt => {
    const currentElem = editor.selection.getNode();
    const isCollapsed = editor.selection.isCollapsed();
    const parentCallout = getParentCallout(editor, currentElem);
    const parentListContainer = editor.dom.getParent(currentElem, 'ul,ol');
    const prevSibling = (parentCallout || currentElem).previousSibling;
    const prevSiblingIsCallout = !!getCalloutType(editor, prevSibling);
    const nextSibling = (parentCallout || parentListContainer || currentElem).nextSibling;
    const nextSiblingIsCallout = !!getCalloutType(editor, nextSibling);
    if (evt.keyCode === KEY_BACKSPACE && isCollapsed && (parentCallout || prevSiblingIsCallout) && !parentListContainer) {
      const bookmark = editor.selection.getBookmark();
      const bookmarkNode = editor.dom.get(`${bookmark.id}_start`);
      const cursorIsAtTheBeginning = isNestedFirstChild(bookmarkNode, currentElem);
      const cursorIsAtTheBeginningOfCallout = cursorIsAtTheBeginning && parentCallout && isNestedFirstChild(bookmarkNode, parentCallout);
      const cursorIsJustBelowCallout = !parentCallout && cursorIsAtTheBeginning && prevSiblingIsCallout;
      editor.selection.moveToBookmark(bookmark);
      if (cursorIsAtTheBeginningOfCallout || cursorIsJustBelowCallout) {
        editor.undoManager.transact(() => {
          evt.preventDefault();
          evt.stopImmediatePropagation();
          if (cursorIsJustBelowCallout && isEmptyParagraph(currentElem)) {
            editor.dom.remove(currentElem);
            const lastLeaf = getLastInnerMostLeaf(prevSibling);
            editor.selection.setCursorLocation(lastLeaf, lastLeaf.length);
          }
        });
      }
    } else if (evt.keyCode === KEY_DELETE && isCollapsed && (parentCallout || nextSiblingIsCallout)) {
      const bookmark = editor.selection.getBookmark();
      const bookmarkNode = editor.dom.get(`${bookmark.id}_start`);
      // When bookmark a is created in a empty <p> it will be the first child of the <p>,
      // so we need to check also for if has a nextSibling which is just a <br>
      const bookmarkNodeNextSibling = bookmarkNode.nextSibling;
      const bookmarkNodeNextSiblingIsBR = bookmarkNodeNextSibling && bookmarkNodeNextSibling.nodeName === 'BR';
      const cursorIsAtTheEnd = bookmarkNodeNextSiblingIsBR && isNestedLastChild(bookmarkNodeNextSibling, currentElem) || isNestedLastChild(bookmarkNode, currentElem);
      const cursorIsAtTheEndOfCallout = cursorIsAtTheEnd && parentCallout && (bookmarkNodeNextSiblingIsBR && isNestedLastChild(bookmarkNodeNextSibling, parentCallout) || isNestedLastChild(bookmarkNode, parentCallout));
      const cursorIsJustAboveCallout = !parentCallout && cursorIsAtTheEnd && nextSiblingIsCallout;
      editor.selection.moveToBookmark(bookmark);
      if (cursorIsAtTheEndOfCallout || cursorIsJustAboveCallout) {
        editor.undoManager.transact(() => {
          evt.preventDefault();
          evt.stopImmediatePropagation();
          if (cursorIsJustAboveCallout && isEmptyParagraph(currentElem)) {
            editor.dom.remove(currentElem);
            const firstLeaf = getFirstInnerMostLeaf(nextSibling);
            editor.selection.setCursorLocation(firstLeaf, 0);
          }
        });
      }
    }
  }, true);
}
function _trackCalloutEdit(editor, editType) {
  trackInteraction(editor, 'tinymceEditCallout', EDIT_CALLOUT, {
    editType,
    version: 'contextualToolbar'
  });
}
const trackCalloutEdit = debounce(_trackCalloutEdit, 400);
export function getCalloutTypeChangeHandler(editor) {
  return (target, type) => {
    editor.undoManager.transact(() => {
      editor.dom.setAttrib(target, CALLOUT_ATTRIBUTE, type);
      editor.dom.setAttrib(target, 'style', '');
      editor.dom.removeClass(target, CALLOUT_CLASSES);
      editor.dom.addClass(target, `${CALLOUT_TYPE_CLASS_PREFIX}-${type}`);
    });
    trackCalloutEdit(editor, 'type');
  };
}
export function getCalloutRemoveHandler(editor) {
  return target => {
    editor.undoManager.transact(() => {
      editor.dom.remove(target);
    });
    trackCalloutEdit(editor, 'remove');
  };
}